export const UPDATE_USER_PREFERENCES_MUTATION = `
    mutation UpdatePreferences($preferences: [KeyValueInput]) {
        updatePreferences(preferences: $preferences) {
            key
            value
        }
    }
`;
